
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.17 6.5h.96v-6h-.7v.12c-.17.76-.84.9-1.41.9h-.1v.63h1.25zm-.35 7.3c.46-1.46 2.4-1.59 2.4-3.58a1.5 1.5 0 00-1.7-1.6c-1.27 0-1.76.74-1.76 1.93h.91c0-.6.12-1.25.84-1.25.54 0 .75.41.75.9 0 1.87-2.52 1.8-2.52 4.42h3.5v-.81zm1.34 6.52v-.03A1.24 1.24 0 0022.1 19a1.43 1.43 0 00-1.58-1.5 1.52 1.52 0 00-1.7 1.7h.9c0-.53.17-1.03.75-1.03.49 0 .68.42.68.85 0 .57-.22 1-.85 1h-.34v.66h.37c.71 0 .95.38.95 1.1 0 .58-.23 1.06-.82 1.06-.64 0-.8-.58-.8-1.1h-.9c0 1.24.6 1.76 1.67 1.76a1.61 1.61 0 001.8-1.82 1.22 1.22 0 00-1.07-1.36zM16.26 3h-7a.5.5 0 000 1h7a.5.5 0 000-1zm0 8.12h-7a.5.5 0 100 1h7a.5.5 0 000-1zm0 8.88h-7a.5.5 0 100 1h7a.5.5 0 100-1zM3.5 0A3.5 3.5 0 107 3.5 3.5 3.5 0 003.5 0zm0 6A2.5 2.5 0 116 3.5 2.5 2.5 0 013.5 6zm.43 2.86a.52.52 0 00-.86 0l-3 5a.5.5 0 00.43.76h6a.5.5 0 00.43-.76zm-2.55 4.76l2.12-3.53 2.12 3.53zM6.6 17.4a.5.5 0 00-.7 0l-2.4 2.4-2.4-2.4a.5.5 0 10-.7.7l2.4 2.4-2.4 2.4a.5.5 0 00.7.7l2.4-2.4 2.4 2.4a.5.5 0 10.7-.7l-2.4-2.4 2.4-2.4a.5.5 0 000-.7z"}})])
          )
        }
      }
    